import Flex from "../Flex";
import React, {Fragment} from "react";
import {Elastic} from "../Flex/styles";
import {BtnTab} from "../../ui";
import {Card} from "./styles";
import {css} from "@emotion/core";

const btnReset = css` 
    background:transparent;
    border:none;
    
    &:focus{
        outline:none;
    }
`;

const Mycard = (props) => {
    return (
        <Card bgT={props.bgT} className={props.className} mxscrol={props.footer ? "390px" : "155px"}>
            {props.tabs ?
                <Flex className={"wc title"} jc={"flex-start"} elastic={"1 0 auto"}>
                    {props.tabs.map((item, index) => (
                        <BtnTab
                            key={index}
                            active={item.active}
                            flex={"1 0 150px"}
                            onClick={() => item.onClick()}
                            classNameBtn={"pt-4 pb-3"}
                        >
                            {item.text}
                        </BtnTab>
                    ))}
                </Flex>
             :
                <Flex
                    className={"wc title py-3"}
                    jc={"flex-start"}
                    elastic={"0 0 auto"}
                >
                    {props.back && props.visible ? (
                        <Fragment>
                            <div className="col-2 px-lg-4">
                                <button
                                    onClick={ () => {
                                        if(props.customBack){
                                            props.history.push(props.back);
                                            props.customBack();
                                        }else{
                                            props.history.push(props.back)
                                        }
                                    }}
                                    css={btnReset}
                                    className={"wc f02 text-left back-button"}
                                    disabled={props.disabled}
                                >
                                    <img
                                        src="https://multimedia.epayco.co/dashboard/recaudo/proyecto/imagenes/back.png"
                                        alt=""
                                    />
                                </button>
                            </div>
                            <div className="col-8 text-center">
                                <p className={"mb-0"}>{props.title}</p>
                            </div>
                        </Fragment>
                    ) : (
                        <p className={"mb-0 wc text-center " + props.titleClass}>{props.title}</p>
                    )}
                </Flex>
            }
            <div className={"myscroll wc"} style={{overflow:"hidden auto"}}>
                <div className="child wc">
                    {props.children}
                </div>
            </div>
            {props.footer && (
                <Elastic className={"footer wc"}>{props.footer}</Elastic>
            )}
        </Card>
    );
};


export default Mycard;
